import { render } from "./Budget.vue?vue&type=template&id=647a7c16&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"

import "./Budget.vue?vue&type=style&index=0&id=647a7c16&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647a7c16"]])

export default __exports__